import React, { Component } from 'react';
import { State } from './combinedReducer';
import initializePusher from 'services/Pusher';
import { CombinedActions, CombinedActionTypes } from './actionsFactory';
import MessageResponse from 'model/MessageTypes/Responses';
import {useAccount} from "~/authentication/store";
import toast from '~/reusable-components/notifications/toast';
import { ScoringEvent, HostScore, getHostMetricsLevelLabelAndIcon, getHostScoringTypeLabel } from 'utils/HostMetrics';

interface PusherHandlerProps {
  dispatch: (options: CombinedActionTypes) => void;
  actions: CombinedActions;
  state: State;
}

class PusherHandler extends Component<PusherHandlerProps & { accountId: string }> {
  socket = initializePusher();

  componentDidMount() {
    const channel = this.socket.subscribe(`private-${this.props.accountId}`);
    channel.bind('NewMessage', (message: MessageResponse) => this.updateReducers(message));
    channel.bind('UpdatedMessage', (message: MessageResponse) => this.updateReducers(message));
    channel.bind('TripUpdate', (message: MessageResponse) => this.updateReducers(message));
    channel.bind('NewScoringEvent', this.showNewScoringEventNotification);
    channel.bind('ScoreUpdated', this.showScoreUpdatedNotification);
  }

  componentWillUnmount() {
    this.socket.unsubscribe(`private-${this.props.accountId}`);
  }

  showNewScoringEventNotification = ({ type, points }: ScoringEvent) => {
    toast({
      text: `You have ${points > 0 ? 'earned': 'lost'} ${points} points in your ${getHostScoringTypeLabel(type)} score!`,
      icon: points > 0 ? '✅' : '😮‍💨',
    })
  }

  showScoreUpdatedNotification = ({ level, type }: HostScore) => {
    const  { label, icon } = getHostMetricsLevelLabelAndIcon(level)
    toast({
      text: `You have reached ${label} level for ${getHostScoringTypeLabel(type)}!`,
      icon,
    })
  }

  updateReducers = (message: MessageResponse) => {
    if (message.from === this.props.accountId && message.status === 'READ') {
      this.props.actions.messages.markOwnConversationAsRead({ accountId: this.props.accountId, contactId: message.to });
    } else if (!this.props.state.contacts[message.from]) {
      this.props.actions.chatContacts.fetchContacts({ page: 1, pageSize: 10 });
      this.props.actions.actionsRequired.fetchActionsRequired({ page: 1, pageSize: 10 });
    } else {
      this.props.dispatch({ type: 'MESSAGES:NEW_MESSAGE', payload: message });
    }

    const messageCopy: any = message;
    if (messageCopy.trip_id && this.props.state.bookings[messageCopy.trip_id]) {
      this.props.actions.bookings.fetchBooking({ id: messageCopy.trip_id });
    }

    // Sometimes a message is pushed with only and id property, this can happen when a booking comes in.
    if (messageCopy.trip_id || Object.keys(messageCopy).length === 1) {
      this.props.actions.upcomingBookings.fetchUpcomingBookings({ page: 1, pageSize: 10 });
    }
  };

  render() {
    return null;
  }
}

function PusherHandlerRenderer({ actions, dispatch, state}: PusherHandlerProps) {
  const { account } = useAccount();
  const accountId = account?.id;

  if (accountId) {
    return (
      <PusherHandler dispatch={dispatch} actions={actions} state={state} accountId={accountId} />
    );
  }
  return null;
}

export default PusherHandlerRenderer;
